// Файл: src/Components/ResetPasswordPage.js

import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const ResetPasswordPage = () => {
    const [email, setEmail] = useState('');
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        // Здесь должна быть логика для отправки ссылки на сброс пароля

        // Опционально: показать сообщение об успешной отправке или перенаправить
        navigate('/login');
    };

    return (
        <div className="login-container">
            <h2>Сброс пароля</h2>
            <form className="login-form" onSubmit={handleSubmit}>
                <input type="email" placeholder="Введите Ваш E-mail" value={email} onChange={e => setEmail(e.target.value)} required />
                <button type="submit">Отправить ссылку</button>
            </form>
            <h5>Вспомнили пароль? <a href="/login">Войти</a></h5>
        </div>
    );
};

export default ResetPasswordPage;
